import {
  Button,
  Col,
  FormControl,
  FormGroup,
  Grid,
  Row,
} from 'react-bootstrap';
import React from 'react';

import Editor from '../editor/editor.jsx';

const ChangeInsightsAnalysisDetails = (props) => {
  const {
    readyToEdit,
    setReadyToEdit,
    fullText,
    readyToApply,
    isFirstGeneration,
    setAdditionalPrompt,
    handleFinishInput,
    handleAnalyzeSurvey,
    handleSaveResults,
    isAiAnalysisExist,
    editorData,
    setEditorInstance,
    hasError,
    received,
    loading,
  } = props;

  const cancelMsg = 'Are you sure you want to exit? Changes won’t be saved';

  return (
    <Grid>
      <Row>
        <Col sm={12}>
          {!readyToEdit && !hasError && fullText && (
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <div style={{ whiteSpace: 'pre-wrap' }} className="m-b-28">
                    {fullText}
                  </div>
                </Col>
              </Row>
            </div>
          )}
          {!hasError && readyToApply && !readyToEdit && (
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <React.Fragment>
                    {!isFirstGeneration && (
                      <FormGroup>
                        <FormControl
                          type="textarea"
                          componentClass="textarea"
                          placeholder="Enter additional prompt here to adjust results"
                          rows={5}
                          onChange={(e) => setAdditionalPrompt(e.target.value)}
                        />
                      </FormGroup>
                    )}
                    <div className="flex flex-justify">
                      <div>
                        <Button
                          bsStyle="primary"
                          type="button"
                          onClick={handleFinishInput}
                        >
                          Apply
                        </Button>
                        {!hasError ? (
                          <button
                            type="button"
                            className="btn-clear btn-link m-l-12"
                            onClick={handleAnalyzeSurvey}
                          >
                            Re-generate with prompt
                          </button>
                        ) : null}
                      </div>

                      {(isAiAnalysisExist || received) && (
                        <Button
                          bsStyle="default"
                          onClick={() => {
                            if (!window.confirm(cancelMsg)) return;
                            window.location.reload();
                          }}
                        >
                          Cancel
                        </Button>
                      )}
                    </div>
                  </React.Fragment>
                </Col>
              </Row>
            </div>
          )}
          {editorData ? (
            <div className="component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding">
              <Row>
                <Col sm={10} smOffset={1}>
                  <React.Fragment>
                    <Editor
                      options={{
                        holder: 'analysis-editor',
                        readOnly: !readyToEdit,
                        minHeight: 0,
                      }}
                      setEditorInstanceForParent={setEditorInstance}
                      data={editorData}
                    />
                    {readyToEdit && (
                      <div className="flex flex-justify">
                        <Button
                          bsStyle="primary"
                          type="button"
                          onClick={handleSaveResults}
                          disabled={loading}
                        >
                          {loading ? 'Saving...' : 'Save'}
                        </Button>
                        {(isAiAnalysisExist || received) && (
                          <Button
                            bsStyle="default"
                            onClick={() => {
                              if (!window.confirm(cancelMsg)) return;
                              window.location.reload();
                            }}
                          >
                            Cancel
                          </Button>
                        )}
                      </div>
                    )}
                  </React.Fragment>
                </Col>
              </Row>
            </div>
          ) : null}
        </Col>
      </Row>
    </Grid>
  );
};

export default ChangeInsightsAnalysisDetails;
